import React from 'react';

function QASection() {
  return (
    <>
      <p>
        Tapahtuman perustaja voi halutessaan lisätä tapahtumaansa Q&A osion, jolloin muut käyttäjät voivat jättää
        tapahtumaan kysymyksiä.
      </p>
      <p>
        Q&A osion käyttöönotto on ilmainen kaikille äsenille. Kaikessa kanssakäymisessä haluamme varmistaa, että kyseessä
        on oikea ihminen eikä kyselyosio täyty ns. &quot;spämmikysymyksistä&quot;.
      </p>
      <p>
        Kysymykset auttavat tapahtuman järjestäjää tekemään tapahtumasta mahdollissimman hyödyllisen myös muille
        osallistujille.
      </p>
    </>
  );
}

export default QASection;

